import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '@/utils/error-utils';

export const { RSCSerializationError } = errorFactory('RSCSerializationError');

/**
 * Error thrown when parameters are not RSC-serializable.
 *
 * This error is thrown when attempting to pass non-serializable values
 * to React Server Components or server functions, which require all
 * parameters to be JSON-serializable.
 */
export type RSCSerializationError = InstanceTypeOf<
  typeof RSCSerializationError
>;
